package com.zaurh.mapquizmobile.presentation.navigation

import DailyRewardsScreen
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.navigation.NavHostController
import androidx.navigation.compose.NavHost
import androidx.navigation.compose.composable
import com.zaurh.mapquizwebsite.presentation.screen.home.HomeScreen
import com.zaurh.mapquizwebsite.presentation.screen.main.MainViewModel

@Composable
fun NavGraph(
    modifier: Modifier = Modifier,
    viewModel: MainViewModel,
    navController: NavHostController
) {
    NavHost(
        modifier = modifier,
        navController = navController,
        startDestination = Screen.DailyRewardsScreen.route
    ) {
        composable(
            route = Screen.HomeScreen.route,
        ) {
            HomeScreen()
        }
        composable(
            route = Screen.DailyRewardsScreen.route,
        ) {
            DailyRewardsScreen()
        }
    }
}